import styled from 'styled-components';

import { Text } from '../Text';
import { Box } from '../Box';

export const StyledButton = styled.button<{
    autoStretch?: boolean;
    buttonSize?: string;
    mb?: number;
    borderRadius?: number;
    disabled?: boolean;
}>`
    display: flex;
    cursor: pointer;
    align-items: center;
    ${({ mb }) => mb && `margin-bottom: ${mb}px;`};
    width: ${({ autoStretch }) => (autoStretch ? '100%' : 'fit-content')};
    border-radius: ${({ borderRadius }) => borderRadius}px;
    background-color: ${({ theme }) => theme['surface-main']};
    border: 1px solid ${({ theme }) => theme['border-default']};
    transition: 0.3s;
    overflow: hidden;
    pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

    &:hover {
        background-color: ${({ theme }) => theme['surface-hovered']};
    }

    &:active {
        background-color: ${({ theme }) => theme['surface-hovered']};
    }
`;

export const InnerButtonContainer = styled(Box)`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
`;

export const LoaderWrapper = styled(Box)<{ isLoading?: boolean }>`
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${({ theme }) => theme['surface-main']};
    visibility: ${({ isLoading }) => (isLoading ? 'visible' : 'hidden')};
    opacity: ${({ isLoading }) => (isLoading ? '1' : '0')};
`;

export const Title = styled(Text)`
    display: flex;
    justify-content: ${({ center }) => (center ? 'center' : 'space-between')};
    text-align: ${({ center }) => (center ? 'center' : 'left')};
    align-items: center;
    gap: 8px;
    width: 100%;
`;
